import { 
  SET_PROFILE, 
  CHK_ACC_START, 
  CHK_ACC_SUCCESS, 
  CHK_ACC_FAILURE, 
  FETCH_CAPB_START, 
  FETCH_CAPB_SUCCESS, 
  FETCH_CAPB_FAIL, 
  SET_BU,
  FETCH_USER_PREFERENCE_START,
  FETCH_USER_PREFERENCE_SUCCESS,
  FETCH_USER_PREFERENCE_FAIL,
  SAVE_USER_PREFERENCE_START,
  SAVE_USER_PREFERENCE_SUCCESS,
  SAVE_USER_PREFERENCE_FAIL
} from "./profileTypes";

export const setProfile = (payload) => ({
  type: SET_PROFILE,
  payload,
});

export const chkAccAct = (eid) => ({
    type: CHK_ACC_START,
    eid,
  });
  
  export const chkAccSuccAct = (payload) => ({
    type: CHK_ACC_SUCCESS,
    payload,
  });
  
  export const chkAccFailAct = (error) => ({
    type: CHK_ACC_FAILURE,
    error,
  });
  

  export const fetchCabpAct = (eid) => (
    {
      type: FETCH_CAPB_START,
      eid
    }
  );

  export const fetchCapbSuccAct = (payload) => (
    {
      type: FETCH_CAPB_SUCCESS,
      payload
    }
  );

  export const fetchCapbFailAct = (error) => (
    {
      type: FETCH_CAPB_FAIL,
      error
    }
  )

  export const setBuAction = (payload) =>(
    {
      type: SET_BU,
      payload
    }
  )

  // User Preferences Actions
  
  // Fetch User Preference (GET)
  export const fetchUserPreferenceAct = (payload) => ({
    type: FETCH_USER_PREFERENCE_START,
    payload
  });

  export const fetchUserPreferenceSuccessAct = (payload) => ({
    type: FETCH_USER_PREFERENCE_SUCCESS,
    payload
  });

  export const fetchUserPreferenceFailAct = (error) => ({
    type: FETCH_USER_PREFERENCE_FAIL,
    error
  });

  // Save User Preference (POST)
  export const saveUserPreferenceAct = (payload) => ({
    type: SAVE_USER_PREFERENCE_START,
    payload
  });

  export const saveUserPreferenceSuccessAct = (payload) => ({
    type: SAVE_USER_PREFERENCE_SUCCESS,
    payload
  });

  export const saveUserPreferenceFailAct = (error) => ({
    type: SAVE_USER_PREFERENCE_FAIL,
    error
  });